/*
 * Form.tsx  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";

import { BEM } from "@adapptio/lib-components";
import { isFunction } from "@adapptio/lib-shared";

export interface IFormProps extends React.ComponentPropsWithRef<"form"> {
	className?: string;
}

export const Form: React.FC<IFormProps> = React.forwardRef(
	({ children, className, onSubmit, ...props }, ref) => {
		const baseClass = BEM("edt-form");

		const handleSubmit = useCallback<React.FormEventHandler>(
			(event: React.FormEvent<HTMLFormElement>) => {
				event.preventDefault();

				if (isFunction(onSubmit)) {
					onSubmit(event);
				}
			},
			[ onSubmit ]
		);

		if (className) {
			baseClass.add(className);
		}

		return (
			<form className={baseClass.toClassName()} ref={ref} onSubmit={handleSubmit} {...props}>
				{children}
			</form>
		);
	}
);
